/** Shared page gutter — Room Lobby / gameplay / leaderboard outer inset */
export const PAGE_OUTER_PADDING_TOP = 20;
export const PAGE_OUTER_PADDING_X = 25;
/** @deprecated Prefer PAGE_OUTER_PADDING_TOP / PAGE_OUTER_PADDING_X; kept as vertical alias */
export const PAGE_OUTER_PADDING = PAGE_OUTER_PADDING_TOP;

/** Figma Rapchik Revamped — pastel glass panel */
export const HOUSIE_GLASS_CARD_STYLE = {
  position: 'relative',
  borderRadius: 36,
  background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.5) 100%)',
  border: '2px solid #FFFFFF',
  boxShadow: '0px 4px 22px 0px rgba(255, 255, 255, 0.7)',
  backdropFilter: 'blur(25px)',
  WebkitBackdropFilter: 'blur(25px)',
  overflow: 'visible',
  boxSizing: 'border-box',
};

/** Figma 17742:25792 / 25818 — side panels ~372 wide */
export const HOUSIE_SIDE_PANEL_STYLE = {
  ...HOUSIE_GLASS_CARD_STYLE,
  borderRadius: 20,
  flex: '0 0 372px',
  width: 372,
  maxWidth: '28%',
  minWidth: 280,
  minHeight: 640,
  padding: 20,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  boxSizing: 'border-box',
};

/**
 * Figma 18423:6237 — Rap Housie gameplay right sidebar stack
 * Outer column only; CLAIMED / TOTAL MEMBERS each own a glass card.
 */
export const RAP_HOUSIE_RIGHT_PANEL_STYLE = {
  flex: '0 0 400px',
  width: 400,
  maxWidth: '30%',
  minWidth: 300,
  minHeight: 640,
  maxHeight: '100%',
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  overflow: 'hidden',
  boxSizing: 'border-box',
  background: 'transparent',
  border: 'none',
  boxShadow: 'none',
};

/** Figma 18423:3739 — RapFire gameplay TOTAL MEMBERS column (400×720 glass card) */
export const RAP_FIRE_RIGHT_PANEL_STYLE = {
  flex: '0 0 400px',
  width: 400,
  maxWidth: 400,
  minWidth: 320,
  minHeight: 720,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  alignSelf: 'stretch',
  overflow: 'visible',
  boxSizing: 'border-box',
  background: 'transparent',
  border: 'none',
  boxShadow: 'none',
};

/** Figma 18011:21879 — full-width top bar, bottom corners only */
export const HOUSIE_TOP_BAR_STYLE = {
  width: '100%',
  minHeight: 90,
  borderRadius: '0 0 36px 36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  marginBottom: 24,
  boxSizing: 'border-box',
};

/** Figma Revamped — bottom strip (ads / sponsors), pastel glass */
export const HOUSIE_BOTTOM_BAR_STYLE = {
  width: '100%',
  minHeight: 96,
  marginTop: 20,
  borderRadius: 36,
  background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.5) 100%)',
  border: '2px solid #FFFFFF',
  boxShadow: '0px 4px 22px 0px rgba(255, 255, 255, 0.7)',
  backdropFilter: 'blur(25px)',
  WebkitBackdropFilter: 'blur(25px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 16,
  padding: '12px 20px',
  boxSizing: 'border-box',
  overflow: 'hidden',
};

/** Inner clip for rounded content inside a glass card */
export const HOUSIE_GLASS_CARD_CLIP_STYLE = {
  borderRadius: 36,
  overflow: 'hidden',
  width: '100%',
  height: '100%',
  boxSizing: 'border-box',
};

/** Figma Rapchik Revamped — page background */
export const RAPCHIK_CONSOLE_BG_GRADIENT =
  'linear-gradient(90deg, #FBA3F9 0%, #C8B6FC 48%, #BCC9FF 100%)';

/** Revamped page fill used behind cover background image */
export const RAPCHIK_PAGE_BG_COLOR = '#E8D9FF';

/**
 * Figma 18110:2766 — "bg blured" full-screen frosted overlay
 */
export const RAPCHIK_BLURRED_BG_OVERLAY_STYLE = {
  position: 'absolute',
  inset: 0,
  zIndex: 0,
  pointerEvents: 'none',
  backgroundImage:
    'linear-gradient(95.015deg, rgba(255, 0, 242, 0.2) 1.5%, rgba(130, 42, 255, 0.1) 97.5%)',
  backdropFilter: 'blur(25px)',
  WebkitBackdropFilter: 'blur(25px)',
};

/**
 * Figma 18011:22064 / 22066 — 100px timer ring overlaid on bottom arch center.
 * Arch edge at center is ~13.12% above the frame bottom (inverted path).
 */
export const RAP_FIRE_QUESTION_COUNT_WRAP_STYLE = {
  position: 'relative',
  width: 100,
  height: 100,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 6,
  pointerEvents: 'none',
  overflow: 'visible',
};

/** @deprecated Prefer LiveGameVideoStage — kept for fallbacks */
export const LIVE_GAME_VIDEO_FRAME_STYLE = {
  width: '100%',
  flex: '0 1 auto',
  minHeight: 220,
  maxHeight: 520,
  aspectRatio: '960 / 519',
  borderRadius: 10,
  overflow: 'hidden',
  position: 'relative',
  border: '3px solid #ff00f2',
  boxSizing: 'border-box',
  background: '#0E0E0E',
};

/** @deprecated Prefer LiveGameVideoStage */
export const LIVE_GAME_VIDEO_WRAP_STYLE = {
  position: 'relative',
  width: '100%',
  marginTop: 8,
  marginBottom: 20,
  overflow: 'visible',
};

/** Figma 18011:22068 — counter digits Medium 30.637 / 40.85 / tracking 1.02 */
export const RAP_FIRE_QUESTION_COUNT_TEXT_STYLE = {
  margin: 0,
  fontFamily: 'Inter, Montserrat, system-ui, sans-serif',
  fontWeight: 500,
  fontSize: 30.637,
  lineHeight: '40.85px',
  letterSpacing: 1.0212,
  color: '#FFFFFF',
  whiteSpace: 'nowrap',
  textAlign: 'center',
};

export const LIVE_GAME_SECTION_TITLE_STYLE = {
  margin: 0,
  fontFamily: 'Inter, Montserrat, system-ui, sans-serif',
  fontWeight: 500,
  fontSize: 24,
  lineHeight: '32px',
  letterSpacing: 0.8,
  color: '#003',
  textAlign: 'center',
  textShadow: '0px 1px 0px #ff00f2',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
};

/** Pastel member / claimed row fill (Figma 18011:21931) */
export const LIVE_GAME_MEMBER_ROW_GRADIENT =
  'linear-gradient(180deg, #ffdbfd 0%, #e0cbff 100%)';
